module.exports = __webpack_public_path__ + "static/img/linda_jumping.7e4a09e.png";